var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2630,
    height: 1767,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 363,
    width: 2630,
    height: 1767
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-885 -363)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 363,
    width: 2630,
    height: 1767,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2971.34 1255.22C3172.9 1742.48 2762.58 2049.92 2268.12 2049.92 1773.66 2049.92 1372.79 1694.14 1372.79 1255.22 1372.79 816.295 1771.56 423.918 2265.99 423.918 2760.42 423.918 2939.69 629.222 2971.34 1255.22",
    fill: "#EBF2FC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2534.24 430.5C2534.24 430.5 2524.56 611.293 2436.37 744.74L2436.37 835.136C2436.37 837.819 2367.39 905.055 2344.32 927.474 2339.57 932.098 2336.91 938.422 2336.91 945.052L2336.91 1033.16 2321.78 1033.16C2307.27 1033.16 2295.5 1044.94 2295.5 1059.46L2295.5 1421.94C2295.5 1436.05 2306.94 1447.5 2321.04 1447.5L2746.63 1447.5C2765.33 1447.5 2780.5 1432.32 2780.5 1413.61L2780.5 1238.73",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2535.5 430.5C2535.5 430.5 2545.15 611.448 2633.13 745.009L2633.13 835.482C2633.13 838.167 2701.87 905.395 2724.91 927.877 2729.67 932.526 2732.35 938.878 2732.35 945.536L2732.35 1033.65 2754.65 1033.65C2766.72 1033.65 2776.5 1043.47 2776.5 1055.59L2776.5 1157.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2691.5 1212.5C2691.5 1298.1 2622.1 1367.5 2536.5 1367.5 2450.9 1367.5 2381.5 1298.1 2381.5 1212.5 2381.5 1126.9 2450.9 1057.5 2536.5 1057.5 2622.1 1057.5 2691.5 1126.9 2691.5 1212.5Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2536.5 1057.5 2536.5 1212.78 2406.5 1298.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2336.5 935.5 2732.5 935.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2436.5 835.5 2516.5 835.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2632.5 835.5 2579.5 835.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2436.5 743.5 2632.5 745.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519.5 2042.27 1633.27 2042.27C1649.46 2042.27 1662.59 2031.31 1662.59 2015.09L1662.59 1853.51C1662.59 1845.36 1664.31 1837.33 1667.67 1829.91 1685.22 1791.13 1741.8 1656.47 1733.6 1548.86 1734.67 1549.93 1730.5 1671.86 1798.96 1829.64 1801.3 1835.01 1802.45 1840.8 1802.45 1846.65L1802.45 1929.35C1802.45 1941.73 1812.48 1951.77 1824.84 1951.77L2014.33 1951.77C2025.06 1951.77 2033.76 1943.06 2033.76 1932.32L2033.76 1850.23C2033.76 1842.13 2035.61 1834.16 2039.18 1826.91 2057.06 1790.65 2112.68 1667.95 2109.06 1552.09 2112.22 1553.14 2108.15 1687.93 2171.96 1831.37 2174.49 1837.07 2175.75 1843.25 2175.75 1849.49L2175.75 2010.02C2175.75 2029.63 2191.63 2045.5 2211.18 2045.5L2312.91 2045.5C2329.24 2045.5 2342.5 2032.23 2342.5 2015.87L2342.5 1547.48C2342.5 1514.73 2332.32 1482.79 2313.39 1456.09L2301.62 1439.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1919.5 1849.5 1919.5 2041.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.5 1845.5 2027.5 1846.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.5 1920.5 1801.5 2041.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2033.5 1920.5 2037.5 2039.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2727.5 2041.5 2727.5 1496.46C2727.5 1481.74 2733.97 1467.76 2745.18 1458.27L2772.5 1435.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2598.5 1519.5 2598.5 1729.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2600.5 1787.5 2600.5 2041.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470.5 1542.5 2470.5 2040.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.5 1845.5 1801.5 1845.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2036.5 1845.5 2174.5 1845.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2341.5 1846.5 2729.5 1846.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2343.5 1652.5 2725.5 1652.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.5 2042.5 2957.5 2042.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.08a776768b1ee8c113ce688e5a11a4d8.svg";
export { ForwardRef as ReactComponent };